/**
 * Parses a VScrollBar through the shared ScrollBar base (Control, Range and `custom_step`).
 * VScrollBar adds no properties. Only the draw axis differs, and the Component handles it.
 */
import { parseScrollBar } from '../shared/scrollBar';
export function parseVScrollBar(heading, properties) {
    return parseScrollBar(heading, properties);
}
//# sourceMappingURL=parser.js.map